<template>
  <div class="d-flex flex-column align-items-center">
    <div class="d-flex flex-column col-12 col-sm-8 col-md-6 col-lg-5 col-xl-3 container"
         :class="{ 'ro-brand': brandConfig?.brand === 'ro-fantasy-dribble' }"
         :style="backgroundImage">
      <div class="router-view-container">
        <router-view></router-view>
      </div>
      <div v-if="brandConfig?.brand === 'ro-fantasy-dribble'" class="lang-swap-cinematic-overlay" aria-hidden="true"></div>
    </div>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {setBrandConfig} from "./functions/setBrandConfig";

export default {
  data() {
    return {
      isSelectVoucherRoute: false,
    };
  },
  computed: {
    ...mapState(['brandConfig']),
    backgroundImage() {
      const brand = this.brandConfig?.brand;
      if (!brand) return {};
      if (brand === 'ro-fantasy-dribble') {
        return {
          backgroundImage: `url(${require('@/brand/ro-fantasy-dribble/assets/background/page-background.webp')})`,
        };
      }
      if (this.isSelectVoucherRoute && this.brandConfig?.selectVoucherBackground) {
        return {
          backgroundImage: `url(${this.brandConfig.selectVoucherBackground})`,
        };
      }
      if (brand === 'vc-za-fantasy-dribble') {
        return {
          backgroundImage: `url(${require('@/brand/vc-za-fantasy-dribble/assets/Fantasy Dribble/fantasy-htc-bg.png')})`,
        };
      }
      if (brand === 'vc-za-cricket-zone') {
        return {
          backgroundImage: `url(${require('@/brand/vc-za-cricket-zone/Cricket Zone/cricket-bg.png')})`,
        };
      }
      try {
        return {
          backgroundImage: `url(${require(`@/brand/${brand}/assets/background/background-image.webp`)})`,
        };
      } catch (error) {
        console.warn('Background image not found for brand:', brand, error);
        return {};
      }
    }
  },
  watch: {
    '$route.name': {
      immediate: true,
      handler(routeName) {
        this.isSelectVoucherRoute = routeName === 'SelectVoucher';
      }
    }
  },
  methods: {
    setFavicon() {
      const favicon = document.getElementById("favicon");
      favicon.href = require(`./assets/vc-logo.png`)
    },
  },
  beforeMount() {
    setBrandConfig();
    this.setFavicon();
  }
}
</script>
<style>
@font-face {
  font-family: 'Poppins';
  src: url('~@/assets/fonts/poppins/Poppins-Light.ttf') format('truetype');
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Poppins';
  src: url('~@/assets/fonts/poppins/Poppins-Regular.ttf') format('truetype');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Poppins';
  src: url('~@/assets/fonts/poppins/Poppins-Medium.ttf') format('truetype');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Poppins';
  src: url('~@/assets/fonts/poppins/Poppins-SemiBold.ttf') format('truetype');
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Poppins';
  src: url('~@/assets/fonts/poppins/Poppins-Bold.ttf') format('truetype');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Poppins';
  src: url('~@/assets/fonts/poppins/Poppins-Black.ttf') format('truetype');
  font-weight: 900;
  font-style: normal;
  font-display: swap;
}

.container {
  position: fixed;
  height: 100vh;
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;
  font-family: 'Poppins', sans-serif;
}
.container.ro-brand {
  background-size: 100% 100%;
  background-position: center;
  background-color: #1a1a1a;
}

.router-view-container {
  position: relative;
  top: 34vh;
}

.container.ro-brand .router-view-container {
  top: 0;
  padding-top: 26vh;
  height: 100vh;
  overflow-y: auto;
}

/* Language swap cinematic animation (mirrors client.soccer-zone behaviour) */
:root.lang-swap-active .router-view-container {
  overflow: hidden;
  animation: langSwapContentFade 740ms cubic-bezier(0.2, 0.9, 0.25, 1) both;
}
.lang-swap-cinematic-overlay {
  position: absolute;
  inset: 0;
  z-index: 4;
  pointer-events: none;
  opacity: 0;
  overflow: hidden;
}
.lang-swap-cinematic-overlay::before {
  content: '';
  position: absolute;
  top: -24%;
  left: -150%;
  width: 110%;
  height: 165%;
  background: linear-gradient(
    90deg,
    rgba(231, 21, 28, 0) 0%,
    rgba(231, 21, 28, 0.2) 28%,
    rgba(231, 21, 28, 0.9) 50%,
    rgba(231, 21, 28, 0.2) 72%,
    rgba(231, 21, 28, 0) 100%
  );
  transform: rotate(-18deg) translate3d(0, 0, 0);
  transform-origin: center;
  filter: blur(1.8px);
  backdrop-filter: blur(1.4px);
  will-change: transform, opacity, filter;
}
:root.lang-swap-active .lang-swap-cinematic-overlay {
  animation: langSwapOverlayPulse 740ms cubic-bezier(0.2, 0.9, 0.25, 1) both;
}
:root.lang-swap-active .lang-swap-cinematic-overlay::before {
  animation: langSwapOverlaySlide 740ms cubic-bezier(0.2, 0.9, 0.25, 1) both;
}
@keyframes langSwapContentFade {
  0% { opacity: 1; }
  50% { opacity: 0.94; }
  100% { opacity: 1; }
}
@keyframes langSwapOverlayPulse {
  0% { opacity: 0; }
  50% { opacity: 0.94; }
  100% { opacity: 0; }
}
@keyframes langSwapOverlaySlide {
  0% { transform: rotate(-18deg) translate3d(0, 0, 0); }
  50% { transform: rotate(-18deg) translate3d(210%, 0, 0); }
  100% { transform: rotate(-18deg) translate3d(430%, 0, 0); }
}

/* Inactive state - submit button remains clickable for feedback */
.submit-btn-inactive {
  cursor: pointer !important;
  pointer-events: auto !important;
}

</style>
